import { NgModule } from '@angular/core';

import { MasterSearch0Actions } from './master-search-0.actions';

@NgModule({
  providers: [
    MasterSearch0Actions
  ]
})
export class MasterSearch0ActionsModule {}
